import { createContext, useContext } from 'react'

type Field = { name: string; isDontUse: boolean }
export type LifeFieldSetContext = {
  fields: Field[]
  onChangeField: (field: Field) => void
  isEveryFieldDontUse: boolean
  isMounted: boolean
}

const LifeFieldSetContext = createContext<LifeFieldSetContext | null>(null)

const useOptionalLifeFieldSetContext = (): Partial<LifeFieldSetContext> => {
  const context = useContext(LifeFieldSetContext)

  return context ?? { isMounted: false }
}

const Provider = LifeFieldSetContext.Provider

export { Provider, useOptionalLifeFieldSetContext }
